import React from 'react';

function WaveLoader({ size = 'medium' }) {
  const dotSize = size === 'small' ? 6 : size === 'large' ? 10 : 8;
  return (
    <div className={`wave-loader wave-loader--${size}`}>
      {[0, 1, 2, 3, 4].map(i => (
        <span
          key={i}
          className="wave-loader__dot"
          style={{
            width: dotSize,
            height: dotSize,
            animationDelay: `${i * 0.12}s`,
          }}
        />
      ))}
    </div>
  );
}

export default WaveLoader;
